import type { LogTransducerErrorFunction } from './types'

// @ts-expect-error Ignore global process object
// eslint-disable-next-line no-underscore-dangle
const NOT_PROD = process.env.NODE_ENV !== 'production'

function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message
  return String(error)
}

export const logTransducerError: LogTransducerErrorFunction = (
  namespace,
  error,
  event
) => {
  if (NOT_PROD) {
    // eslint-disable-next-line no-console
    console.error(
      `[${namespace}] Transducer`,
      `${getErrorMessage(error)}\n\n`,
      event
    )
  }
}
